<template lang="pug">
  div.wrap-user.f.fh
    div.user-content
      div.f.fc
        v-avatar(size="120px").mb8
          v-img(:src="user.photoURL")
      div.mb16
        div.f.fc.mb8
          div.f
            span.bold.fz16.block.text-center.mr4 {{user.name}}
            v-icon(@click="$emit('showModal', 'editProfile')" size="22px") edit
        div.f.fc
          span.profile.fz14.block {{user.profile}}
      div.f.fc
        span(@click="logout").logout.fz12 ログアウト
</template>

<style lang="scss" scoped>
.wrap-user {
  width: 100%;
  min-height: 100vh;
  .user-content {
    width: 93%;
    max-width: 820px;
    margin: 0 auto;
    .profile {
      max-width: 300px;
    }
    .logout {
      color: #f44366;
    }
  }
}
</style>

<script>
import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers("auth")

export default {
  components: {
  },
  computed: {
    ...mapStateAuth(["uid"])
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActionsAuth(["signOut"]),
    logout () {
      this.signOut()
      setTimeout(this.toSignInPage, 400)
    },
    toSignInPage () {
      const path = (this.$route.name === "trainee-user") ? "/sign-in" : "/trainer/sign-in"
      this.$router.push(path)
    }
  }
}
</script>
